export enum SearchBarTypes {
  NONE = 'NONE',
  EXPANDABLE_SEARCH = 'EXPANDABLE_SEARCH',
}
